import { css } from '@emotion/core';
import { colorsPalette, hexToRgba } from '../../../styles/colors';
import { typography, fontWeights } from '../../../styles/typography';
import { MediaQueries } from '../../../styles/Grid';

export const card_component_top = css({
  padding: '24px 0px 0px 0px',
  marginBottom: '0px',
  borderBottom: '#D9DBDD solid 1px',
});

export const containerSizesTop = {
  margin: '128px 0px 0px',
  [MediaQueries.sm]: {
    margin: '64px 0px 0px',
    width: '100%',
  },
  [MediaQueries.md]: {
    margin: '96px 0px 0px',
    width: '100%',
  },
  [MediaQueries.lg]: {
    margin: '96px 0px 0px',
    width: '100%',
  },
};

export const brandlogo = css({
  // width: '100%',
  '.grid-4': { display: 'flex', justifyContent: 'space-between' },
  '.grid-3': { display: 'flex', justifyContent: 'space-between' },

  h2: {
    marginBottom: '0px',
    fontSize: '32px',
    lineHeight: '32px',
    letterSpacing: '-0.4000000059604645px',
    textAlign: 'left',
    fontWeight: 500,

    [MediaQueries.sm]: {
      fontSize: '28px',
      lineHeight: '32px',
      marginBottom: '0px',
    },

    [MediaQueries.md]: { fontSize: '28px', lineHeight: '32px' },
  },

  '.regus-button-prev': {
    position: 'absolute',
    top: '45%',
    zindex: '99999',
    cursor: 'pointer',
    border: '0',
    outline: '0px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0,0,0,0.12)',
    backgroundColor: '#fff',
    padding: '18px',
    left: '-13px',
  },

  '.regus-button-next': {
    position: 'absolute',
    top: '45%',
    zindex: '99999',
    cursor: 'pointer',
    border: '0',
    outline: '0px',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    boxShadow: '0px 5px 20px rgba(0,0,0,0.12)',
    backgroundColor: '#fff',
    padding: '18px',
    right: '-13px',
  },

  '.hr_sec': {
    hr: {
      borderTop: '1px solid #FAD3CC',
    },
  },
});

export const cardscomponent = css({
  ':first-child': {
    paddingLeft: '0px',
    [MediaQueries.sm]: {
      paddingLeft: '15px',
    },
  },
  ':last-child': {
    paddingRight: '0px',
    [MediaQueries.sm]: {
      paddingRight: '15px',
    },
  },
  '.card_sec': {
    maxWidth: '192px',
    height: '192px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    marginBottom: '31px',
    [MediaQueries.sm]: {
      maxWidth: '152px',
      height: '152px',
      padding: '0px',
      justifyContent: 'center',
    },
    [MediaQueries.md]: {
      maxWidth: '144px',
      height: '144px',
      padding: '0px',
      justifyContent: 'center',
    },
    [MediaQueries.lg]: {
      maxWidth: '136px',
      height: '136px',
      padding: '0px',
    },

    h2: {
      fontSize: '16px',
      fontStyle: 'normal',
      marginTop: '0px',
      marginBottom: '16px',
      color: '#e52500',
      fontWeight: 400,
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',

      span: {
        borderBottom: '#fad3cc solid 1px',
      },
    },

    p: {
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 400,
      color: '#858585',
      lineHeight: '24px',
      letterSpacing: '0px',
      textAlign: 'left',
      margin: '0',
    },

    img: {
      maxWidth: '160px',
      [MediaQueries.sm]: {
        maxWidth: '120px',
      },
      [MediaQueries.md]: {
        maxWidth: '112px',
      },
      [MediaQueries.lg]: {
        maxWidth: '104px',
      },
    },
  },
});
export const sectionTitle = css({
  color: 'red',
  h2: {
    color: '#393939',
    fontSize: '40PX',
    lineHeight: '56px',
    fontWeight: '500',
    letterSpacing: '-0.3px',
    marginBottom: 32,
    marginTop: 32,
  },

  [MediaQueries.lgAndUp]: {
    h2: {
      color: '#393939',
      fontSize: '48PX',
      lineHeight: '48px',
      fontWeight: '500',
      letterSpacing: '-0.1px',
      marginBottom: 40,
      marginTop: 40,
    },
  },
});

export const goBackButtonContainer = css({
  marginBottom: 48,
});

export const goBackButton = css(typography.effra16, {
  border: 0,
  background: colorsPalette.transparent,
  color: colorsPalette.black,
  display: 'flex',
  alignItems: 'center',
  padding: 0,
  cursor: 'pointer',
});

export const goBackButtonLabel = css({
  marginLeft: 10,
});

export const mainItemstop = css({
  marginBottom: 50,
});

export const mainItems = css({
  color: '#a2a2a2',
  fontSize: '14px',
  lineHeight: '1.75',
  // '.classname': { padding: '10px' },
  a: {
    color: '#393939',
    fontWeight: '600',
    textDecoration: 'none',
    display: 'block',
    fontWeight: '400',
    lineHeight: '40px',
    marginBottom: '16px',
    fontSize: '28px',
    letterSpacing: '-0.4px',
  },
});

export const itemHolder = css({
  marginBottom: 50,
});

export const underline = css({
  borderBottom: '1px solid #D9DBDD',
  marginBottom: '8px',
  display: 'inline-block',
});

export const subItems = css({
  color: '#a2a2a2',
  lineHeight: '1.75',
  a: {
    color: '',
    fontWeight: '500',
    paddingLeft: '5px',
    textDecoration: 'none',
    color: '#393939',
  },
  '.subItems': {
    paddingLeft: '15px',
    fontSize: '14px',
    a: {
      fontWeight: '400',
    },
  },
});
